// extracted by mini-css-extract-plugin
export default {"content":"Section_content__VA6tL"};